parasails.registerPage('tweet-manager', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    isLive: false,
    autoSendTweets: false,
    updateAllExisting: false,
    currentPartID: 0,
    currentHashtags: '',
    tweetCount: 0,
    eventPartOptions: {},
    tweetTab: 0
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    this.isLive = this.eventData.isLive;
  },

  mounted: async function() {
    if(this.eventData.parts[this.partIndex].hashtags) {this.currentHashtags = this.eventData.parts[this.partIndex].hashtags.join(', ');}
    if(this.eventData.parts[this.partIndex].eventPartOptions) {this.eventPartOptions = this.eventData.parts[this.partIndex].eventPartOptions;}
    this.tweetCount = 0;
    if(this.eventData.meta && this.eventData.meta.result_count) {
      this.tweetCount += this.eventData.meta.result_count;
    }
    if(this.eventData.dbTweets) {
      this.tweetCount += this.eventData.dbTweets.length;
    }

    io.socket.on(this.eventData.id, (params) => {
      console.log('Received Socket Event with params: ' + JSON.stringify(params));
      switch(params.eventType) {
        case 'update':
          //TODO: Implement a function to update the twitter feed
          break;
        default:
          console.log('Received Socket Event with params: ' + JSON.stringify(params));
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    approveTweet: function(tweettext, username, tweetid, autosend = false) {
      this.setApprovedOrRejected(tweetid, true);
      io.socket.post('/approve-tweet', { eventid: this.eventData.id, tweetText: tweettext, userName: username, tweetID: tweetid, sendTweet: autosend, eventPartOptions: this.eventPartOptions });
    },
    sendTweet: function(tweettext, username, tweetid) {
      this.setApprovedOrRejected(tweetid, true);
      io.socket.post('/sendtweet', { eventid: this.eventData.id, tweetText: tweettext, userName: username, tweetID: tweetid, eventPartOptions: this.eventPartOptions });
    },
    hideTweet: function() {
      io.socket.post('/hidetweet', { eventid: this.eventData.id });
    },
    clearAll: function() {
      io.socket.post('/clearall', { eventid: this.eventData.id });
    },
    rejectTweet: function(tweettext, username, tweetid) {
      this.setApprovedOrRejected(tweetid, false);
      io.socket.post('/reject-tweet', { eventid: this.eventData.id, tweetText: tweettext, userName: username, tweetID: tweetid });
    },
    setApprovedOrRejected: function(tweetid, approved = true)
    {
      var foundTweet = false;
      console.log("FOUND " + this.eventData.tweets.length + " tweets.");
      for(let i=0; i < this.eventData.tweets.length; i++) {
        if(this.eventData.tweets[i].id === tweetid) {
          this.eventData.tweets[i].approved = approved;
          this.eventData.tweets[i].rejected = !approved;
          this.$set(this.eventData.tweets, i, this.eventData.tweets[i]);
          foundTweet = true;
          break;
        }
      }
      if(foundTweet === false)
      {
        console.log("found tweet was false.");
        for(let i=0; i < this.eventData.dbTweets.length; i++) {
          if(this.eventData.dbTweets[i].messageID === tweetid) {
            this.eventData.dbTweets[i].approved = approved;
            this.eventData.dbTweets[i].rejected = !approved;
            this.$set(this.eventData.dbTweets, i, this.eventData.dbTweets[i]);
            break;
          }
        }
      }
    },
    updatePartSettings: async function(partIndex) {
      if(this.eventData.parts[partIndex]) {
        await Cloud.editPart.with({id: this.eventData.parts[partIndex].id, data: this.eventData.parts[partIndex]});
      }
      io.socket.post('/option-update', { eventid: this.eventData.id, partid: this.eventData.parts[partIndex].id, partindex: partIndex, eventPartOptions: this.eventData.parts[partIndex].eventPartOptions, updateExisting: this.updateAllExisting});
    },
    removeHashtag: function(hashtag)
    {

    },
    addHashtag: function() {

    }
  }
});
